import React from 'react';
import styled from 'styled-components';
import zoom from '../../../../assets/icons/icon-zoom.svg';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 16px;
  background: var(--button-secondary-main);
  border-radius: 4px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  img {
    margin-right: 4px;
  }

  &:hover {
    background-color: var(--primary-hover);
  }

  &:focus {
    background-color: var(--primary-focus);
  }

  &:active {
    background-color: var(--primary-active);
  }

  @media (min-width: 640px) {
    width: 160px;
  }
`;

interface ButtonZoomProps {
  // onClick: () => void;
  urlZoom: string;
}

const ButtonZoom = ({ urlZoom }: ButtonZoomProps) => {
  const onClick = () => window.open(urlZoom, '_blank');

  if (!urlZoom) {
    return <div data-testid="cmp-button-zoom-empty" />;
  }
  return (
    <Button
      data-testid="cmp-button-zoom"
      onClick={onClick}
      className="fadeTransition"
    >
      <img src={zoom} alt="icon" />
      <span>Unirme al zoom</span>
    </Button>
  );
};

export default ButtonZoom;
